<template>
  <img 
    :src="displaySrc" 
    :alt="alt" 
    :class="imgClass"
    :style="imgStyle"
    @error="onError"
    @load="onLoad"
  />
</template>

<script>
import { getValidImageUrl, DEFAULT_IMAGE } from '@/utils/imageHandler'

export default {
  name: 'CommonImage',
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    fallback: {
      type: String,
      default: DEFAULT_IMAGE
    },
    imgClass: {
      type: [String, Object, Array],
      default: ''
    },
    imgStyle: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      displaySrc: '',
      hasError: false
    }
  },
  watch: {
    src: {
      immediate: true,
      handler(newVal) {
        this.hasError = false
        this.displaySrc = getValidImageUrl(newVal)
      }
    }
  },
  methods: {
    onError() {
      if (!this.hasError) {
        this.hasError = true
        this.displaySrc = this.fallback
      }
    },
    onLoad() {
      this.$emit('load')
    }
  }
}
</script>